import * as React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'

const Hero = ({ title }) => {
  const data = useStaticQuery(graphql`
    query HeroQuery {
      wpPartnerSeite {
        partnerseite {
          premium
          identity {
            customHeroImage {
              localFile {
                publicURL
                extension
                childImageSharp {
                  gatsbyImageData(
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
          }
        }
      }
    }
  `)

  const customHeroImage =
    data.wpPartnerSeite.partnerseite.identity?.customHeroImage?.localFile
      ?.childImageSharp?.gatsbyImageData
  const partnerIsPremium = data.wpPartnerSeite.partnerseite.premium

  const heroImage =
    partnerIsPremium && customHeroImage ? (
      <GatsbyImage
        className="col-start-1 row-start-1 [mix-blend-mode:var(--hero-blend-mode)]"
        image={customHeroImage}
        alt=""
      />
    ) : (
      <StaticImage
        className="col-start-1 row-start-1 [mix-blend-mode:var(--hero-blend-mode)]"
        src="../assets/images/moodbild-x-05-min.png"
        alt=""
      />
    )

  return (
    <div className="grid">
      {heroImage}
      <div className="col-start-1 row-start-1 bg-[color:var(--primary-colour)] w-full h-full" />
      <div className="relative grid items-center col-start-1 row-start-1">
        <h1 className="container max-w-screen-md px-6 mx-auto text-center text-white drop-shadow">
          <span className="text-3xl font-semibold uppercase md:text-5xl">
            {title}
          </span>
        </h1>
      </div>
    </div>
  )
}

export default Hero

Hero.propTypes = {
  title: PropTypes.string,
}
